import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { Partner } from '../../models/stack9/Partner';

import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

type ApplicationDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partner;
};

export const ApplicationDrawer = ({
  open,
  onClose,
  id,
  initialValues,
}: ApplicationDrawerProps) => {
  const formFields = [
    { field: 'country', colSize: 12 },
    { field: 'published_template_uuid', colSize: 12 },
    { field: 'organisation_id', colSize: 12 },
    { field: 'partner_id', colSize: 12 },
    { field: 'submitted_by_id', colSize: 12 },
    { field: 'submitted_dt', colSize: 12 },
    { field: 'assessed_by_id', colSize: 12 },
    { field: 'certification_number', colSize: 12 },
    { field: 'award_dt', colSize: 12 },
    { field: 'expiry_dt', colSize: 12 },
    { field: 'organisation_size', colSize: 12 },
    { field: 'payable_amount', colSize: 12 },
  ];

  return (
    <EntityDrawer
      title="application"
      formFields={formFields}
      initialValues={initialValues}
      id={id}
      open={open}
      onClose={onClose}
      screenQueryName={EDetailsQueryNames.GetApplicationDetails}
      entityName={entityNames.APPLICATION}
      editRoute={AppRoutes.ApplicationDetail}
      relativePath={AppRoutes.ApplicationList}
    />
  );
};
